import { Component, inject } from '@angular/core';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import { ApiService } from '../../../../services/api.service';

@Component({
  selector: 'app-elimina-cliente-backoffice',
  templateUrl: './elimina-cliente-backoffice.component.html',
  styleUrls: ['./elimina-cliente-backoffice.component.css']
})
export class EliminaClienteBackofficeComponent {

  constructor(private apiService: ApiService) { }

  loading: boolean = false;

  readonly #modal = inject(NzModalRef)
  readonly nzModalData = inject(NZ_MODAL_DATA);

  onElimina() {
    this.loading = true;

    // Elimino il cliente
    this.apiService.deleteCliente(this.nzModalData.id_cliente!).subscribe({
      next: (data) => this.apiService.setClienti(),
      error: (err) => {
        this.loading = false;
        this.apiService.error(err.error.message);
      },
      complete: () => {
        this.#modal.destroy();
        this.loading = false;
      }
    })

  }

  onClose() {
    this.#modal.destroy();
  }

}